import { ApiQuery, getAppMarketContextForApi } from './api';
import { AppCollectionScenarios, ServerFeatures } from '../models/enums';
import i18n from '../i18n';
import { parseLocale } from './i18n/locale';
import { AppsInCollectionParameters } from '../redux/api/types';

export const getMerchantQuery = (merchantId: Maybe<Uuid> = ''): Partial<ApiQuery> => {
  const { contextType, id } = getAppMarketContextForApi();
  return {
    namespace: 'v3',
    baseResource: 'accounts',
    baseResourceId: '',
    nestedResources: ['current', contextType],
    filters: [`id=${merchantId || id}`],
    expands: [
      'address',
      'merchantPlan.modules',
      'merchantPlan.appBundle',
      //'logos', 'gateway', 'enterprises', 'selfBoardingApplication', 'owner', 'compliance', 'reseller', 'merchantBoarding'
    ],
  };
};

export const getRatingsAndReviewsQuery = (): Partial<ApiQuery> => {
  return {
    nestedResources: ['server_feature', ServerFeatures.RatingsAndReviews],
  };
};

export const getAppCategoriesQuery = (categoryId: Uuid): Partial<ApiQuery> => {
  return {
    baseResource: 'apps',
    baseResourceId: categoryId,
    nestedResources: ['categories'],
    filters: ['type=FUNCTIONAL', 'nonEmpty=true'],
  };
};

export const getAppCollectionsQuery = (scenario: AppCollectionScenarios = AppCollectionScenarios.AppMarket, appUUID?: Uuid): Partial<ApiQuery> => {
  const query: Partial<ApiQuery> = {
    nestedResources: ['app_collections'],
    customQueries: [
      { scenario },
      {
        clientCountry: i18n?.language ? parseLocale(i18n?.language).country : 'US',
      },
    ],
  };

  if (appUUID) {
    query.customQueries?.push({ appUUID });
  }

  return query;
};

export const getAppMarketPermissionsQuery = (merchantId: Uuid): Partial<ApiQuery> => {
  const { contextType } = getAppMarketContextForApi();
  return {
    baseResource: 'accounts',
    baseResourceId: '',
    nestedResources: ['current', contextType, 'apps', 'com.clover.apps', 'permissions'],
    nestedResourcesIds: ['', merchantId],
    customQueries: [
      {
        expands: 'apps',
      },
    ],
  };
};

export const getMerchantBillingQuery = (): Partial<ApiQuery> => {
  return {
    namespace: 'billing/v3',
    nestedResources: ['status'],
  };
};

export const getAppsInCollectionQueries =(appsInCollectionParameters:AppsInCollectionParameters): Partial<ApiQuery>=>{
  const query: Partial<ApiQuery> = {
    nestedResources: ['app_collections', 'apps'],
    nestedResourcesIds: [appsInCollectionParameters.appCollectionUuid],
    expands: ['appLocales'],
    customQueries: [
      {
        clientCountry: i18n?.language ? parseLocale(i18n?.language).country : 'US',
      },
    ],
    offset: appsInCollectionParameters.offset,
    limit: appsInCollectionParameters.limit
  };
  if (appsInCollectionParameters.sorts) query.sorts = appsInCollectionParameters.sorts;
  return query;
}
